import { useContext, useEffect, useState } from "react";
import { LocaleContext } from "../../contexts/LocaleContext";
import sa_flag from "../../assets/images/sa_flag.jpg";
import provider_profile from "../../assets/images/provider_profile.jpg";
import saad from "../../assets/images/saad.png";
import { Link, useParams } from "react-router-dom";
import { customerService } from "../../services/customerService";
import { urlConfig } from "../../config/baseUrl";
import Loading from "../../components/common/Loading";
import BackButton from "../../components/common/BackButton";
import no_image_available from "../../assets/images/no_image_available.png";

const CustomerDetails = () => {
  const { t, lang } = useContext(LocaleContext);
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    getDetails();
  }, []);

  const getDetails = async () => {
    try {
      const res = await customerService.getDetail(id);
      setData(res.value);
      console.log(res.value);
    } catch (error) {
      console.error("Error fetching customer details:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <Loading />;
  return (
    <section className="section-client-detaiils">
      <div className="default-heading">{t("Customers")}</div>
      <div className="my-card">
        <div className="my-card-header d-flex justify-content-between align-items-center">
          {t("clientDetails")}
          <BackButton />
        </div>
        <div className="my-card-dark">
          <div className="row">
            <div className="col-12 col-md-4">
              <div className="trip-provider-information">
                <div className="trip-provider-profile-layer">
                  <div className="trip-provider-profile">
                    <img
                      src={
                        data?.imagePath
                          ? `${urlConfig.imageBaseUrl}/${data.imagePath}`
                          : provider_profile
                      }
                      alt="Provider Profile"
                    />
                  </div>
                </div>
                {/* <b>
                  <i className="fas fa-images"></i> {t("edit")}
                </b> */}
              </div>
            </div>
            <div className="col-12 col-md-8">
              <div className="row h-100">
                <div className="col-12 col-md-12">
                  <div className="my-dark-card-items">
                    <div className="my-dark-card-item">
                      <strong>{t("fullName")}</strong>
                      <span>{data?.fullName}</span>
                    </div>
                    <div className="my-dark-card-item">
                      <strong>{t("mobileNo")}</strong>
                      <span className="mobile-number-flag">
                        {data?.phoneNumberCode}
                        <div className="trip-mobile-flag-box">
                          <img alt="SA Flag" src={sa_flag} />
                        </div>
                        {data?.phoneNumber}
                      </span>
                    </div>
                    <div className="my-dark-card-item">
                      <strong>{t("code")}</strong>
                      <span>{data?.code}</span>
                    </div>
                    <div className="my-dark-card-item">
                      <strong>{t("registrationDate")}</strong>
                      <span>{data?.dateJoined?.toDate()}</span>
                    </div>
                    <div className="my-dark-card-item">
                      <strong>{t("gender")}</strong>
                      <span>{data?.gender ? t(data.gender.toLowerCase()) : "-"}</span>
                    </div>
                    <div className="my-dark-card-item">
                      <strong>{t("age")}</strong>
                      <span>{data?.age}</span>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-12">
                  <div className="my-dark-card-items border-0">
                    <div className="my-dark-card-item">
                      <strong>{t("city")}</strong>
                      <span>{data?.city?.[lang]}</span>
                    </div>
                    <div className="my-dark-card-item">
                      <strong>{t("email")}</strong>
                      <span>{data?.email}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className=" mt-3">
          <strong>{t("statistics")}</strong>
          <section className="my-statistics mt-3">
            <div className="row g-3">
              <div className="col-12 col-md-4">
                <div className="my-box my-bg-primary">
                  <b>{t("completedBookings")}</b>
                  <span>{data?.completedBookings || 0}</span>
                  <span>
                    {t("active")} : {data?.activeBookings || 0} | {t("pending")} : {data?.pendingBookings || 0}
                  </span>
                </div>
              </div>
              <div className="col-12 col-md-4">
                <div className="my-box my-bg-dark-blue">
                  <b>{t("totalBookings")}</b>
                  <span>{data?.totalBookings || 0}</span>
                  <span>
                    {t("completed")} : {data?.completedBookings || 0} | {t("canceled")} : {data?.canceledBookings || 0}
                  </span>
                </div>
              </div>
              <div className="col-12 col-md-4">
                <div className="my-box my-bg-primary">
                  <b>{t("totalSpending")}</b>
                  <span>{data?.totalSpending || 0} {t("riyal")}</span>
                  <span>{t("fromCompletedBookings")}</span>
                </div>
              </div>
              <div className="col-12 col-md-4">
                <div className="my-box my-bg-dark-blue">
                  <b>{t("canceledBookings")}</b>
                  <span>{data?.canceledBookings || 0}</span>
                  <span>
                    {t("from")} {data?.totalBookings || 0} {t("canceledBookings")}
                  </span>
                </div>
              </div>
              <div className="col-12 col-md-4">
                <div className="my-box my-bg-primary">
                  <b>{t("averageRating")}</b>
                  <span>{data?.rated || 0}</span>
                  <span>
                    {t("from")} {data?.totalRatings || 0} {t("averageRating")}
                  </span>
                </div>
              </div>
              <div className="col-12 col-md-4">
                <div className="my-box my-bg-dark-blue">
                  <b>{t("noOfReviews")}</b>
                  <span>{data?.noOfReviews || 0}</span>
                  <span>{data?.noOfReviews || 0} {t("noOfReviews")}</span>
                </div>
              </div>
            </div>
          </section>
        </div>
        <div className="row mt-3">
          <div className="col-12 col-md-12">
            <div className="my-card my-card-scroll provider-detail-list-items">
              <div className="my-card-header">{t("recentBookings")}</div>
              {data?.bookings?.length > 0 ? (
                data.bookings.map((booking) => (
                  <Link
                    key={booking.bookingId}
                    to={`/booking-details/${booking.bookingId}`}
                    className="text-decoration-none text-dark"
                  >
                    <div className="provider-latest-updates-item">
                      <div className="mt-2">
                        <div className="d-flex justify-content-between">
                          <p className="provider-latest-updates-item-title">
                            <b>{booking.title?.[lang]}</b>
                          </p>
                          <p>
                            <span className={`badge rounded-pill ${booking.status}`}>
                              {t(booking.status)}
                            </span>
                          </p>
                        </div>
                        <div className="d-flex justify-content-between align-items-center">
                          <p className="provider-latest-updates-item-title">
                            <b>{t("code")}: </b>
                            <span>{booking.code}</span>
                          </p>
                          <p style={{ width: "50px", height: "50px" }}>
                            <img
                              src={
                                booking?.imagePath
                                  ? `${urlConfig.imageBaseUrl}/${booking.imagePath}`
                                  : no_image_available
                              }
                              alt="booking"
                              className="booking-image"
                              style={{ width: "100%", height: "100%", objectFit: "cover" }}
                            />
                          </p>
                        </div>
                        <div className="d-flex justify-content-between">
                          <p className="provider-latest-updates-item-date text-dim">
                            {booking.date?.toDate()}
                          </p>
                          <p className="badge bg-primary d-flex align-items-center">
                            {booking.totalCost} {t("riyal")}
                          </p>
                        </div>
                      </div>
                    </div>
                  </Link>
                ))
              ) : (
                <div>
                  <div className="provider-latest-updates-image-box">
                    <img src={saad} alt="Saad" />
                  </div>
                  <p className="text-center">{t("noRecentBookings")}</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CustomerDetails;
